import { Transaction } from '@/generated/proto/bridge/models/transaction'
import { ProtobufAnyMessage } from '@/types'

export type AddTxToStopListFormValues = {
  creator: string
  transaction: {
    depositChainId: string
    depositTxHash: string
    depositTxIndex: string
    depositBlock: string
    depositToken: string
    depositAmount: string
    depositor: string
    receiver: string
    withdrawalChainId: string
    withdrawalTxHash: string
    withdrawalToken: string
    signature: string
    isWrapped: boolean
    withdrawalAmount: string
    commissionAmount: string
    txData: string
    referralId: string
    merkleProof: string
    epochId: string
  }
}

export type RemoveTxFromStopListFormValues = {
  creator: string
  chainId: string
  txHash: string
  txNonce: string
}

export function buildAddTxToStopListMessage(
  values: AddTxToStopListFormValues,
): {
  messages: ProtobufAnyMessage[]
} {
  const tx: Transaction = {
    depositChainId: values.transaction.depositChainId,
    depositTxHash: values.transaction.depositTxHash,
    depositTxIndex: values.transaction.depositTxIndex,
    depositBlock: values.transaction.depositBlock,
    depositToken: values.transaction.depositToken,
    depositAmount: values.transaction.depositAmount,
    depositor: values.transaction.depositor,
    receiver: values.transaction.receiver,
    withdrawalChainId: values.transaction.withdrawalChainId,
    withdrawalTxHash: values.transaction.withdrawalTxHash ?? '',
    withdrawalToken: values.transaction.withdrawalToken,
    signature: values.transaction.signature ?? '',
    isWrapped: values.transaction.isWrapped,
    withdrawalAmount: values.transaction.withdrawalAmount,
    commissionAmount: values.transaction.commissionAmount,
    txData: values.transaction.txData ?? '',
    referralId: Number(values.transaction.referralId ?? 0),
    merkleProof: values.transaction.merkleProof ?? '',
    epochId: Number(values.transaction.epochId ?? 0),
  }

  return {
    messages: [
      {
        '@type': '/core.bridge.MsgAddTxToStopList',
        transaction: tx,
        creator: values.creator,
      },
    ],
  }
}

export function buildRemoveTxFromStopListMessage(
  values: RemoveTxFromStopListFormValues,
): {
  messages: ProtobufAnyMessage[]
} {
  return {
    messages: [
      {
        '@type': '/core.bridge.MsgRemoveTxFromStopList',
        chainId: values.chainId,
        txHash: values.txHash,
        txNonce: values.txNonce,
        creator: values.creator,
      },
    ],
  }
}
